import { RefObject } from "react";
import { create } from "zustand";

interface IframeStore {
  iframeRef: RefObject<HTMLIFrameElement | null> | null;
  size: ResizeObserverSize | null;
  isVisible: boolean;
  isIframeInitialized: number;
  isIframeBlocked: boolean;
  messageQueue: Array<string>;

  setIframeRef: (ref: RefObject<HTMLIFrameElement | null>) => void;
  setSize: (size: ResizeObserverSize | null) => void;
  setIsVisible: (isVisible: boolean) => void;
  setIsIframeInitialized: () => void;
  setIsIframeBlocked: (value: boolean) => void;
  pushMessageToQueue: (message: string) => void;
  popMessageFromQueue: () => void;
}

const useIframeStore = create<IframeStore>()((set) => ({
  iframeRef: null,
  size: { inlineSize: 0, blockSize: 0 },
  isVisible: false,
  isIframeInitialized: 0,
  isIframeBlocked: false,
  messageQueue: [],

  setIsIframeInitialized: () =>
    set((state) => ({
      isIframeInitialized:
        state.isIframeInitialized !== 2
          ? state.isIframeInitialized + 1
          : state.isIframeInitialized,
    })),

  setIframeRef: (iframeRef) => set({ iframeRef }),

  setSize: (size) => set({ size }),

  setIsVisible: (isVisible) => set({ isVisible }),

  setIsIframeBlocked: (value) => set({ isIframeBlocked: value }),

  pushMessageToQueue: (message) =>
    set((state) => ({
      messageQueue: [...state.messageQueue, message],
    })),

  popMessageFromQueue: () =>
    set((state) => ({
      messageQueue: state.messageQueue.slice(0, -1),
    })),
}));

export default useIframeStore;
